import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import Routes from './config/Routes'
import i18n from '../i18n'
import { ThemeProvider } from 'styled-components'
import { appTheme } from './config/styled'
import Session from '../javascripts/layouts/v2/Session'
import { session_path } from '../routes'
import TagManager from 'react-gtm-module'
import 'css/tailwindcss'

export const SessionContext = React.createContext<Session>(null)

const updateDataLayer = (session: Session) => {
  const userId = session.user?.id

  if (!userId) { return }

  TagManager.dataLayer({ dataLayer: { uid: userId } })
}

const App: React.FC = (): JSX.Element => {
  const [session, setSession] = React.useState<Session>(null)

  // NOTE: ワーカーの各コンポーネントでセッション情報を扱えるようにするため、セッションAPIを実行しています。
  // 詳細 → https://github.com/crowdtech/crowdtech/pull/27412#issuecomment-2154261434
  useEffect(() => {
    void fetch(session_path())
      .then(response => response.json())
      .then((json: Session) => {
        setSession(json)
        updateDataLayer(json)
      })
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <SessionContext.Provider value={session}>
          <ThemeProvider theme={appTheme}>
            <Routes />
          </ThemeProvider>
        </SessionContext.Provider>
      </BrowserRouter>
    </I18nextProvider>
  )
}

export default App
